import { Job } from "generated/graphql";
import React from "react";

export const JobContext = React.createContext(null);

export const JobProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [job, setJob] = React.useState<Job>(null);
  const [orderIndex, setOrderIndex] = React.useState(0);
  const [parcelIndex, setParcelIndex] = React.useState(0);
  const [isUpdateJob, setIsUpdateJob] = React.useState(false);
  const [datePickup, setDatePickup] = React.useState(null);
  const [isPickUp, setIsPickUp] = React.useState(false);
  return (
    <JobContext.Provider
      value={{
        job,
        setJob,
        orderIndex,
        setOrderIndex,
        parcelIndex,
        setParcelIndex,
        isUpdateJob,
        setIsUpdateJob,
        datePickup,
        setDatePickup,
        isPickUp,
        setIsPickUp,
      }}
    >
      {children}
    </JobContext.Provider>
  );
};
